import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, HostListener, Inject, OnInit } from '@angular/core';
import { BehaviorSubject, Observable, Subscriber, throwError } from 'rxjs';
import { WINDOW } from "./windows.service";
import { environment } from 'src/environments/environment';
import { SubCategoryDTO,CategoryDTO, TagDTO, CustomerDTO } from '../models/model';
import { NotificationService } from './notification.service';
import { LocalDataSource } from 'ng2-smart-table';
import { catchError } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
  })
export class authervice implements OnInit {
    public Source:LocalDataSource;

    constructor(private http: HttpClient) {
        this.Source = new LocalDataSource();
    }

    ngOnInit(): void {
        throw new Error('Method not implemented.');
    }

    login(customer: CustomerDTO): Observable<any> {
        return this.http.post<any>(`${environment.apiUrl}/Account/connect`, customer, { withCredentials: true }
        );
    }

  public setAdmin(role: string) {
    debugger
    if (role == "Admin") {
      sessionStorage.setItem('role', role);
    }
  }

  public getRole(): string {
    return sessionStorage.getItem('role');
  }



    private handleError(error: HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
          // A client-side or network error occurred. Handle it accordingly.
          console.error('An error occurred:', error.error.message);
        } else {
          // The backend returned an unsuccessful response code.
          // The response body may contain clues as to what went wrong,
          console.error(
            `Backend returned code ${error.status}, ` +
            `body was: ${error.error}`);
        }
        // return an observable with a user-facing error message
        return throwError(error.error);
      };



}